import { createIconComponent } from '@element-plus/components/icons-vue/helper'

export const redoSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" d="m15 15 6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3" />
</svg>`

export default createIconComponent({
  name: 'Redo',
  svg: redoSvg,
})
